import React from "react";
import "redcircle-brand-css/scss/redcircle.scss";
import { classNames } from "react-extras";
import isNil from "lodash/isNil";
const Divider = props => {
  const { smallMargin, marginTop, marginBottom, className } = props;
  let defaultMargin = "28px";
  if (!isNil(smallMargin)) {
    defaultMargin = "12px";
  }
  return (
    <hr
      className={classNames("redcircle-divider", className)}
      style={{
        marginTop: marginTop ?? defaultMargin,
        marginBottom: marginBottom ?? defaultMargin,
      }}
    />
  );
};

export default Divider;
